<template>
  <div class="code-box">
    <div class="code-top-box">
      <div
        class="code-top-bg"
        :style="{ backgroundImage: `url(${headerBgUrl})` }"
      >
        <div class="top-banner-center">
          <div class="title-text">
            赋码申请
          </div>
          <div class="title-line" />
          <div class="title-tips">
            提交产品信息生产水泵二维码，在线打印
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="operate-box">
        <el-card shadow="never">
          <div class="time-line-box">
            <el-steps :active="activeStep" align-center>
              <el-step
                :description="item.label"
                v-for="(item, index) in timeLineList"
                :key="index"
                @click.native="onClickStep(index)"
              >
                <span slot="title">
                  <img :src="bindTitleIcon(index)" width="55" alt="" />
                </span>
                <span slot="icon">
                  <img
                    :src="
                      index === activeStep - 1
                        ? timeLineSelectIcon
                        : timeLineNormalIcon
                    "
                    width="28"
                    alt=""
                  />
                </span>
              </el-step>
            </el-steps>
          </div>
          <el-card class="operate-bottom">
            <div v-if="activeStep === 1 && activeType === 0">
              <product-info
                ref="refProductInfo"
                @onChangeType="onChangeType"
                @onChangeStep="onChangeStep"
              />
            </div>
            <div v-else-if="activeStep === 1 && activeType === 1">
              <div class="bottom-title">
                <div class="bottom-text">已申请列表</div>
                <el-button
                  type="primary"
                  size="small"
                  round
                  icon="el-icon-edit-outline"
                  @click="onChangeType(0)"
                >
                  申请赋码
                </el-button>
              </div>
              <applied-list
                ref="refAppliedList"
                @onChangeType="onChangeType"
                @onChangeStep="onChangeStep"
              />
            </div>
            <div v-else-if="activeStep === 2">
              <div class="bottom-title">
                <div class="bottom-text">生成水泵码</div>
              </div>
              <generate-code-list
                ref="refGenerateCode"
                @onChangeStep="onChangeStep"
              />
            </div>
            <div v-else-if="activeStep === 3">
              <create-qrcode
                ref="refCreateQrcode"
                @onChangeType="onChangeType"
                @onChangeStep="onChangeStep"
              />
            </div>
            <div v-else-if="activeStep === 4">
              <print-qrcode
                ref="refPrintQrcode"
                @onChangeType="onChangeType"
                @onChangeStep="onChangeStep"
              />
            </div>
          </el-card>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import appliedList from "./AppliedList"
import ProductInfo from "./ProductInfo"
import CreateQrcode from "./CreateQrcode"
import GenerateCodeList from "./GenerateCodeList"
import PrintQrcode from "./PrintQrcode"

export default {
  //   赋码追溯
  name: "saas",
  metaInfo: {
    title:
      "赋码追溯 - 为水泵行业企业提供信息化赋码追溯服务-宁夏工业企业数字化转型公共服务平台",
    meta: [
      {
        name: "keywords",
        content:
          "宁夏工业企业数字化转型公共服务平台 | 信息化软件 | 智能制造解决方案| 水泵数字化| saas平台 | 平台软件服务 | 企业数字化服务| 企业管理软件",
      },
      {
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台软件超市提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {
    appliedList,
    ProductInfo,
    CreateQrcode,
    GenerateCodeList,
    PrintQrcode,
  },
  data() {
    return {
      headerBgUrl: require("../../assets/codeTraceability/codeBg.png"),
      timeLineSelectIcon: require("../../assets/codeTraceability/coddIcon1.png"),
      timeLineNormalIcon: require("../../assets/codeTraceability/coddIcon0.png"),
      timeLineList: [
        { label: "提交产品信息" },
        { label: "生成水泵码" },
        { label: "设计二维码样式" },
        { label: "打印水泵码" },
      ],
      curProduct: {},
      activeStep: 1,
      activeType: 0, //0:产品信息 1：已申请列表
    }
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  created() {
    if (this.$store.state.isLogin) {
    } else {
    }
    this.getOptionsData()
  },
  mounted() {
    this.$refs.refProductInfo.initData()
  },
  methods: {
    getOptionsData() {
      // getDictionaryItem({
      //   code: 'TENDERING_BACKGROUD'
      // }).then((res) => {
      //   if (res != null && res.length > 0) {
      //     this.headerBgUrl = res[0].value
      //   }
      // });
    },
    bindTitleIcon(index) {
      return require("@/assets/codeTraceability/step" +
        (index + 1) +
        (index === this.activeStep - 1 ? "1" : "0") +
        ".png")
    },
    onClickStep(index) {
      // this.activeStep = index + 1
    },
    onChangeType(type, product) {
      let that = this
      this.activeType = type
      if (this.activeStep === 1) {
        if (type === 1) {
          this.$nextTick(() => {
            that.$refs.refAppliedList.initData()
          })
        } else if (type === 0) {
          this.$nextTick(() => {
            that.$refs.refProductInfo.initData(product)
          })
        }
      }
    },
    onChangeStep(step, product, other) {
      let that = this
      this.activeStep = step
      if (product) {
        if (step === 1 && this.activeType === 0) {
          this.curProduct = product
          this.$nextTick(() => {
            that.$refs.refProductInfo.initData(product)
          })
        } else if (step === 2) {
          this.curProduct = product
          this.$nextTick(() => {
            that.$refs.refGenerateCode.initData(product)
          })
        } else if (step === 3) {
          this.curProduct = product
          this.$nextTick(() => {
            that.$refs.refCreateQrcode.initData(product, other.waterPumpList)
          })
        } else if (step === 4) {
          this.curProduct = product
          this.$nextTick(() => {
            that.$refs.refPrintQrcode.initData(product)
          })
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
.code-box {
  background-color: #f6f6f8;

  /deep/ .el-button--small.is-round {
    padding: 9px 20px;
  }

  .code-top-bg {
    height: 500px;
    width: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: white;

    .top-banner-center {
      width: 1200px;
    }

    .title-line {
      width: 80px;
      height: 1px;
      background-color: white;
      margin: 10px auto 15px;
    }

    .title-text {
      font-weight: bold;
      font-size: 42px;
      letter-spacing: 4px;
    }

    .title-tips {
      font-size: 20px;
      letter-spacing: 2px;
    }
  }

  .operate-box {
    transform: translateY(-80px);
    margin-bottom: -40px;

    .time-line-box {
      margin: 100px 60px 50px;

      /deep/ .el-step__title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -60px;
      }

      /deep/ .el-step.is-center .el-step__description {
        padding-left: 20%;
        padding-right: 20%;
        margin-top: 10px;
        font-size: 16px;
      }

      /deep/ .el-step__icon.is-text {
        border: none;
      }

      //已完成的进度条灰色
      ///deep/ .el-step__head.is-finish {
      //  color: #c0c4cc;
      //  border-color: #c0c4cc;
      //}

      /deep/ .el-step__description.is-process {
        color: #c0c4cc;
      }

      /deep/ .el-step.is-horizontal {
        cursor: pointer;
      }
    }

    .operate-bottom {
      margin: 0 60px;

      .bottom-title {
        border-bottom: 1px solid #cccccc;
        padding-bottom: 20px;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
      }

      .bottom-text {
        color: black;
        font-weight: bold;
        font-size: 24px;
        letter-spacing: 2px;
      }
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .con-title {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-top: 40px;
    padding-top: 40px;
  }
}
</style>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/codeTraceability/index.vue